import * as React from "react";
const Windows10Charging = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={11}
    fill="none"
    {...props}
  >
    <path stroke="#fff" d="M6 2.5h9M4 10.5h10M14.5 3v8M15.5 5v3" />
    <path fill="#fff" d="M7 4h4v5H5V7h1V6h1V4Z" />
    <path stroke="#fff" strokeOpacity={0.64} d="M6.5 5v1M5.5 6v1" />
    <path stroke="#fff" strokeOpacity={0.31} d="M6.5 4v1" />
    <path
      stroke="#fff"
      d="M.5 3v2.5h1v1h2v-1h1V3M2.5 7v4M0 2.5h5M3.5 0v2M1.5 0v2"
    />
  </svg>
);
export default Windows10Charging;
